module.exports = __webpack_public_path__ + "img/img7.1dae9e37.png";